module.exports = __webpack_public_path__ + "static/Freesound-3c0a2a7ecaf59861ffa8d2f1c6ffc6a5.jpg";